/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { requestTypeTableEntrypoint } from '@jira/servicedesk__request-types-table/src/requestTypeTableEntrypoint.entrypoint.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type NestedEntryPointsDef = {
	requestTypeTableEntrypoint: typeof requestTypeTableEntrypoint;
};

type GettingStartedRequestTypesEntryPointComponent = EntryPointComponent<
	{},
	NestedEntryPointsDef,
	{},
	{}
>;

export const gettingStartedRequestTypesEntryPoint: EntryPoint<
	GettingStartedRequestTypesEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<GettingStartedRequestTypesEntryPointComponent>(
		/* webpackChunkName: "async-servicedesk-getting-started-request-types", jiraSpaEntry: "async-servicedesk-getting-started-request-types" */ './RequestTypesPage.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => {
		const projectKey = context.match?.params?.projectKey;
		const cloudId = tenantContext?.cloudId ?? '';
		if (!projectKey || !cloudId) {
			return {};
		}
		return {
			entryPoints: {
				requestTypeTableEntrypoint: {
					entryPoint: requestTypeTableEntrypoint,
					entryPointParams: { projectKey, cloudId },
				},
			},
		};
	},
});
